"use strict";

ko.utils.toJS = function (viewModel) {
    /// <summary>
    /// Removes methods and properties that are not part of the server-side model
    /// Overrides knockout ToJS method to return a regular Javascript Object.
    /// </summary>

    function removeMethodFromJsObject(jsObj) {
        _.each(jsObj, function (value, key, obj) {
            if (_.isFunction(obj[key])) {
                delete obj[key];
            }

            if (_.isArray(obj[key])) {
                _.each(obj[key], function (innerVal, innerKey, innerObj) {
                    removeMethodFromJsObject(innerObj[innerKey]);
                });
            }
        });

        return jsObj;
    }

    return removeMethodFromJsObject(ko.toJS(viewModel));
};